@for (item of items; track item) {
  <span
    class="skeleton-block"
    [style.width]="width"
    [style.height]="height"
    [style.border-radius]="borderRadius"
    [style.margin-bottom]="marginBottom"
    aria-hidden="true"
  ></span>
}
